const CHANGE_LOG_KEY = 'ChangeLogs';

export class StandardChangeLog {
  constructor(private storage: Storage = localStorage) {}

  save(note: string): void {
    this.storage.setItem(CHANGE_LOG_KEY, note);
  }

  clear(): void {
    this.storage.removeItem(CHANGE_LOG_KEY);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/standard-change-log.ts